import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CameraCapture from '../components/CameraCapture';
import Mascot from '../components/Mascot';

export default function Snap() {
  const navigate = useNavigate();
  const [note, setNote] = useState('');

  const handle = (imageDataUrl: string) => {
    sessionStorage.setItem(
      'mb_input',
      JSON.stringify({
        image: imageDataUrl,
        note: note.trim() || undefined,
        source: 'snap',
      })
    );
    navigate('/solve');
  };

  return (
    <div className="max-w-xl mx-auto px-5 pt-10 safe-top space-y-6">
      <header className="flex items-center gap-3">
        <Mascot mood="thinking" size={56} />
        <div>
          <h1 className="font-display font-black text-2xl leading-none">Snap a problem</h1>
          <p className="text-ink/70 text-sm">Fill the frame. Hold steady. We've got this.</p>
        </div>
      </header>

      <CameraCapture onCapture={handle} />

      <div className="space-y-2">
        <label htmlFor="note" className="text-sm font-semibold text-ink/80">
          Add a note <span className="text-ink/50 font-normal">(optional)</span>
        </label>
        <textarea
          id="note"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          rows={2}
          maxLength={300}
          placeholder="e.g., I think the answer is 12 but I'm stuck on part b"
          className="w-full card p-3 text-sm text-ink outline-none focus:ring-2 focus:ring-coral/50"
        />
        <p className="text-xs text-ink/50">
          Tell Professor Buddy what you're thinking — he'll use it to help better.
        </p>
      </div>
    </div>
  );
}
